import { Controller } from "@hotwired/stimulus";

export default class MetamaskController extends Controller {
  static targets = ["button", "status"];

  async connectWallet() {
    if (!globalThis.ethereum) return this.installMetaMask();

    try {
      this.setLoading(true, "Connecting to MetaMask...");
      await this.ensureSepolia();
      const accounts = await globalThis.ethereum.request({ method: "eth_requestAccounts" });
      const address = accounts[0]?.toLowerCase();
      if (!address) throw new Error("No MetaMask account was selected.");

      this.setStatus("Sign the verification message in MetaMask...");
      const challenge = await this.requestJson("/nfts/wallet_challenge", {
        method: "POST",
        body: { address }
      });
      const signature = await globalThis.ethereum.request({
        method: "personal_sign",
        params: [challenge.message, address]
      });
      await this.requestJson("/nfts/wallet_connect", {
        method: "POST",
        body: { address, nonce: challenge.nonce, signature }
      });

      await globalThis.Swal.fire({
        customClass: {
          popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
          htmlContainer: "text-black-paint text-white"
        },
        animation: false,
        text: "Sepolia wallet verified. Purchase is now available.",
        icon: "success",
        timer: 1800,
        showConfirmButton: false
      });
      globalThis.location.reload();
    } catch (error) {
      this.setLoading(false);
      return this.showError(error.message || "Wallet verification failed.");
    }
  }

  async ensureSepolia() {
    const chainId = await globalThis.ethereum.request({ method: "eth_chainId" });
    if (chainId.toLowerCase() !== "0xaa36a7") {
      await globalThis.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: "0xaa36a7" }]
      });
    }
  }

  async requestJson(path, options) {
    const response = await fetch(path, {
      method: options.method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      body: JSON.stringify(options.body)
    });
    const responseText = await response.text();
    let payload = {};
    if (responseText.trim()) {
      try {
        payload = JSON.parse(responseText);
      } catch {
        throw new Error(`Server returned an invalid response (${response.status}).`);
      }
    }
    if (!response.ok) throw new Error(payload.errors?.join(", ") || payload.error || "Wallet verification failed.");
    return payload;
  }

  setLoading(loading, message = "") {
    if (this.hasButtonTarget) this.buttonTarget.disabled = loading;
    if (message) this.setStatus(message);
  }

  setStatus(message) {
    if (!this.hasStatusTarget) return;
    this.statusTarget.textContent = message;
    this.statusTarget.classList.remove("d-none");
  }

  installMetaMask() {
    return globalThis.Swal.fire({
      customClass: {
        popup: "eth-install-popup swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: "Install MetaMask",
      html: "<a class='text-white-paint text-primary fs-30' href='https://metamask.io/download' target='_blank' rel='noopener noreferrer'>Install Now</a>",
      icon: "error",
      confirmButtonText: "OK"
    });
  }

  showError(message) {
    return globalThis.Swal.fire({
      customClass: {
        popup: "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: "Wallet verification failed",
      text: message,
      icon: "error",
      confirmButtonText: "OK"
    });
  }
}
